import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGobackIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.4,
	height: 16.655,
	fill: "",
	viewBox: "0 0 18.4 16.655",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_8434",
		"data-name": "Path 8434",
		d: "M10,19V14h4v5a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V12h1.7a.5.5,0,0,0,.33-.87L12.67,3.6a1.008,1.008,0,0,0-1.34,0L2.97,11.13A.5.5,0,0,0,3.3,12H5v7a1,1,0,0,0,1,1H9A1,1,0,0,0,10,19Z",
		transform: "translate(-2.802 -3.345)"
	})
});
export { SvgGobackIcon as ReactComponent };
